const adminUiTexts = {
	admin: {
		da: 'Admin',
		en: 'Admin'
	},
	logout: {
		da: 'Log ud',
		en: 'Logout'
	},
	lottery: {
		da: 'Lotteri',
		en: 'Lottery'
	},
	email: {
		da: 'E-mail',
		en: 'E-mail'
	},
	newsletter: {
		da: 'Nyhedsbrev',
		en: 'Newsletter'
	},
	submitted: {
		da: 'Dato',
		en: 'Date'
	},

	textToSpeechPopup: {
		title: {
			da: 'Text to speech',
			en: 'Text to speech',
		},
		configuration: {
			da: 'Konfiguration',
			en: 'Configuration'
		},
		language: {
			da: 'Sprog',
			en: 'Language'
		},
		voice: {
			da: 'Stemme',
			en: 'Voice'
		},
		modules: {
			da: 'Moduler',
			en: 'Modules'
		},
		uploadBtn: {
			da: 'Upload tekster',
			en: 'Upload texts'
		}
	}
};

module.exports = {
	adminUiTexts
};